import * as Yup from "yup";

export const CreditingRegularSchema = Yup.object({
  aeroplanNumber: Yup.string().required("crediting.block-form.error.aeroplannumber.required")
  .matches(/^[0-9]+$/, "crediting.block-form.error.aeroplannumber.numeric")
  .min(9, "crediting.block-form.error.aeroplannumber.digits")
  .max(9, "crediting.block-form.error.aeroplannumber.digits"),
  lastName: Yup.string().required("crediting.block-form.error.lastname.required"),
  referenceNumber: Yup.string().required("crediting.block-form.error.referenceNumber.required")
  .matches(/^[0-9aA-zZ]{1,10}$/, "crediting.block-form.error.referenceNumber.invalid"),
  creditedMiles: Yup.string().required("crediting.block-form.error.credited.miles.required")
  .matches(/^-?[0-9]{1,10}$/, "crediting.block-form.error.credited.miles.invalid")
});
